export const SETUP = {
    TODAY_DATE: new Date(),
    START_TIME: '08:00',
    END_TIME: '18:00',
}